window.addEventListener('load', function () {
  // Check if Splide is actually loaded to prevent errors
  if (typeof Splide === 'undefined') {
    console.error('Splide library is not defined. Please check your script loading order.');
    return;
  }

  const sliderOptions = {
    perPage: 1,
    perMove: 1,
    drag: 'free',
    snap: true,
    pagination: false,
    arrows: false,
    gap: 0,
    autoplay: true,
    type: 'loop',
  };

  // querySelector only ever returned the FIRST match, so a template carrying two
  // Landing Slide Details sections left the second slider unmounted - and an
  // unmounted .splide keeps visibility:hidden, which reads as an empty section.
  // Mount every match instead, and claim each container so a second execution
  // of this file is a no-op rather than a double-init.
  function mountAll(selector) {
    const sliders = document.querySelectorAll(selector);

    Array.prototype.forEach.call(sliders, function (slider) {
      const alreadyClaimed = slider.dataset.landingSlideInit === 'true';
      const alreadyMounted = slider.classList.contains('is-initialized');

      if (alreadyClaimed || alreadyMounted) {
        return;
      }

      slider.dataset.landingSlideInit = 'true';
      new Splide(slider, sliderOptions).mount();
    });
  }

  // --- Filter images / Find your perfect fit ---
  mountAll('.slide-landing-details2');

  // --- Section landing slide details 1 ---
  mountAll('.slide-landing-details');
});
